module.exports = __webpack_public_path__ + "static/img/notdata.c5b85c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/datatable/notdata.png
// module id = d46N
// module chunks = 2